import { render } from "./BIA.vue?vue&type=template&id=2a88982c"
import script from "./BIA.vue?vue&type=script&lang=ts"
export * from "./BIA.vue?vue&type=script&lang=ts"
script.render = render

export default script